import { Shimmer } from "../Loading.styles";
import { NubsItem, NubsPlaceholderCol, NubsPlaceholderRow } from "./NubsUpload.style";

const NubsPlaceholder = () => {
  return (
    <>
      {
        Array.from(Array(1).keys()).map((i) => (
            <NubsItem key={i}>
                <NubsPlaceholderRow>
                    {
                        Array.from(Array(6).keys()).map((i) => (
                            <NubsPlaceholderCol className="col--grow" key={i}>
                                <Shimmer type="title" />
                            </NubsPlaceholderCol>
                        ))
                    }
                </NubsPlaceholderRow>
            </NubsItem>
        ))
      }
    </>
  );
};

export default NubsPlaceholder;
